import api from '@/services/api/tnc.js'
import { useState } from 'react'

const useTnc = () => {

	const [tnc, setTnc] = useState("")
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	async function fetch(payload) {

		const tncItem = sessionStorage.getItem('tnc')
		if (tncItem) {
			return setTnc(JSON.parse(tncItem))
		}

		setLoading(true)
		const [errorResponse, response] = await api.getTnC(payload)

		setLoading(false)
		if (errorResponse) {
			return setTnc()
		}
		if (typeof response !== 'object') {
			return setError('TNC is not an object')
		}

		sessionStorage.setItem('tnc', JSON.stringify(response.html))
		return setTnc(response.html)

	}

	async function accept(payload) {

		const [errorResponse, response] = await api.acceptTnC(payload)

		if (errorResponse) {
			return setError('TNC Accept has error')
		}
		return [error, response]
	}

	return {
		error,
		fetch,
		accept,
		tnc,
		loading
	}

}

export default useTnc
